import { api } from './api'
import type { PptPatient, PptPatientUpdateData, PptPatientsImportResponse, PptPatientsListResponse } from '../types/pptPatient'

export const pptPatientService = {
  list: async (params?: { page?: number; pageSize?: number; search?: string }): Promise<PptPatientsListResponse> => {
    const response = await api.get<PptPatientsListResponse>('/ppt-patients', { params })
    return response.data
  },

  importCsv: async (file: File): Promise<PptPatientsImportResponse> => {
    const csvContent = await file.text()
    const response = await api.post<PptPatientsImportResponse>('/ppt-patients/import-csv', {
      fileName: file.name,
      csvContent,
    })
    return response.data
  },

  update: async (id: string, data: PptPatientUpdateData): Promise<PptPatient> => {
    const response = await api.put<PptPatient>(`/ppt-patients/${id}`, data)
    return response.data
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/ppt-patients/${id}`)
  },
}
